import { particleAtlas } from "./particles";

// Count the atlas's visible texels at screenshot pixel centers. Transparent
// margins make a nominal eight pixel quad too small at some subpixel positions.
export function dizzyStarPixelSize(
  x: number,
  y: number,
  size: number,
  minimumAlpha = 90,
) {
  const data = particleAtlas.image.data!;
  let left = Infinity,
    right = -Infinity,
    top = Infinity,
    bottom = -Infinity;
  for (let py = Math.floor(y - size / 2); py < y + size / 2; py++)
    for (let px = Math.floor(x - size / 2); px < x + size / 2; px++) {
      const u = (px + 0.5 - x) / size + 0.5;
      const v = 0.5 - (py + 0.5 - y) / size;
      if (u < 0 || u >= 1 || v < 0 || v >= 1) continue;
      const alpha =
        data[(Math.floor(v * 32) * 96 + 32 + Math.floor(u * 32)) * 4 + 3]!;
      if (alpha < minimumAlpha) continue;
      left = Math.min(left, px);
      right = Math.max(right, px);
      top = Math.min(top, py);
      bottom = Math.max(bottom, py);
    }
  return { w: Math.max(0, right - left + 1), h: Math.max(0, bottom - top + 1) };
}

export function minimumDizzyStarSize(x: number, y: number, size: number) {
  const original = dizzyStarPixelSize(x, y, size);
  if (original.w >= 6 && original.h >= 6) return size;
  let clamped = size;
  for (; clamped < Math.max(size + 4, 12); clamped += 0.125) {
    const pixels = dizzyStarPixelSize(x, y, clamped, 190);
    // Leave half a pixel on each edge for multisample coverage and tint blending.
    if (pixels.w >= 6 && pixels.h >= 6) return clamped + 1;
  }
  return clamped;
}
